import React, { useEffect } from 'react';

const StarfinderSection = () => {
  useEffect(() => {
    // Inicializar el comportamiento de los acordeones
    const accordionButtons = document.querySelectorAll('.accordion-button');
    accordionButtons.forEach(button => {
      if (button.classList.contains('collapsed')) {
        button.style.backgroundColor = '#ffffff'; // Estilo por defecto (cerrado)
        button.style.color = '#000'; // Color de texto por defecto
      } else {
        button.style.backgroundColor = '#353535'; // Estilo cuando está abierto
        button.style.color = '#fff'; // Color de texto cuando está abierto
      }
    });
  }, []);

  return (
    <section className="pathfinder-section">
   

      <div className="accordion mt-3 mb-3">
        <div className="accordion-item">
          <h2 className="accordion-header">
            <button className="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#sfs2links">
              <span className='fs-5 fw-bold'>Enlaces de interés SFS2e</span>
            </button>
          </h2>
          <div id="sfs2links" className="accordion-collapse collapse">
            <div className="accordion-body">
              <p className='mb-0'>Los siguientes enlaces pueden ser útiles en el Juego Organizado de Starfinder 2e</p>
              <ul>
                <li className='mb-0 mt-0'><a target="_blank" href="https://downloads.paizo.com/OP-Files/SFS+Invasions+Edge+Players+Guide.pdf">Guía de jugador - Temporada 1: Al Borde de la Invasión</a></li>
                <li className='mb-0 mt-0'><a target="_blank" href="https://lorespire.paizo.com/tiki-index.php?page=sfs2guide._.Full-Guide">Guía de Juego Organizado para Pathfinder 2e</a></li>
                <li className='mb-0 mt-0'><a target="_blank" href="https://paizo.com/starfinderSociety/characteroptions">Opciones de Personajes</a></li>
                <li className='mb-0 mt-0'><a target="_blank" href="https://paizo.com/starfindersociety/faq">FAQs de Starfinder</a></li>
                <li className='mb-0 mt-0'><a target="_blank" href="https://paizo.com/products/btq0e20l?Community-Use-Package-Starfinder-Second-Edition-Iconic-Pregenerated-Characters">Personajes pregenerados</a></li>                
              </ul>
            </div>
          </div>
        </div>
      </div>

      <div className="accordion mt-3 mb-3">
        <div className="accordion-item">
          <h2 className="accordion-header">
            <button className="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#sfs2eyear1">
              <span className='fs-5 fw-bold'>Temporada 1: Al Borde de la Invasión</span>
            </button>
          </h2>
          <div id="sfs2eyear1" className="accordion-collapse collapse p-3">

            <p>
            Tras el Vacío —ese inexplicable lapso en la historia que sacudió a toda la galaxia y provocó la desaparición del mundo de Golarion— nació la Sociedad Starfinder. Desde entonces, nos hemos convertido en una de las organizaciones más importantes de los Mundos del Pacto. Gracias al Salto, el don del dios-máquina Triun, los Starfinders nos lanzamos a explorar estrellas lejanas y sistemas olvidados, guiados siempre por nuestro líder elegido: el Primer Buscador.
            </p>

            <p>
            Los tesoros que descubrimos y el conocimiento que registramos aseguraron nuestro prestigio durante generaciones.
            </p>

            <p>
            Pero ahora, algo ha cambiado.
            </p>

            <p>
            Hace apenas unas semanas, una colosal nave alienígena emergió de la oscuridad del espacio profundo y entró en la atmósfera superior de Akiton a una velocidad que podría haber partido el planeta en dos. En el último momento, redujo su velocidad y se estrelló en las Colinas de Sloughscar. Allí, curiosos, saqueadores y exploradores se apresuraron a llegar… incluidos algunos agentes bajo contrato con la Sociedad Starfinder.
            </p>

            <p>
            Pero en cuestión de horas, la nave activó sus defensas automáticas. Criaturas monstruosas, efectos mágicos descontrolados y tecnología letal expulsaron a todos los intrusos. A esta nave la conocemos ahora como <strong>la Ruina del Retornado</strong>.
            </p>

            <p>
            Las investigaciones iniciales han llevado al Primer Buscador Sarmak a una terrible sospecha: la Ruina del Retornado está relacionada con los <strong>Primeros</strong>, una antigua civilización de la que apenas quedan rastros… y podría ser la primera señal de una invasión galáctica inminente.
            </p>

            <p>
            Aunque… algo no encaja.
            </p>

            <p>
            Sarmak ha establecido una base en las propias Colinas de Sloughscar y ha emitido un llamado urgente. Necesita a los Starfinders más valientes: agentes dispuestos a proteger este nuevo enclave y a adentrarse en las profundidades de la Ruina del Retornado, cueste lo que cueste.
            </p>

            <p>
            <strong>Bienvenidos a <em>Al Borde de la Invasión</em>, la primera temporada de la Sociedad Starfinder para <em>Starfinder Segunda Edición</em>.</strong>
            </p>

     
          </div>
        </div>
      </div>

    </section>
  );
};

export default StarfinderSection;
